export default "__VITE_ASSET__40eb2014__"